class ReactFormatterCapitalize extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <span>
                {this.props.value.charAt(0).toUpperCase() + this.props.value.slice(1)}
            </span>
        )
    }
}